import React from 'react';
import { Tabs, Tab } from '@material-ui/core';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const DesktopNavTabs = props => {
  const classes = useStyles();
  const { list, activeTab, handleChangeActiveTab } = props;

  return (
    <Tabs
      value={activeTab}
      onChange={handleChangeActiveTab}
      className={classes.list}
      indicatorColor="primary"
      textColor="primary"
    >
      {list.map(({ label, id }) => (
        <Tab key={id} label={label} value={id} disableRipple className={classes.item} />
      ))}
    </Tabs>
  );
};

DesktopNavTabs.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  activeTab: PropTypes.number.isRequired,
  handleChangeActiveTab: PropTypes.func.isRequired,
};

export default DesktopNavTabs;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/DesktopNavTabs/DesktopNavTabs.js